import { render, staticRenderFns } from "./complex-menu-variant-list-card.vue?vue&type=template&id=31bbcac3&scoped=true&"
import script from "./complex-menu-variant-list-card.vue?vue&type=script&lang=ts&"
export * from "./complex-menu-variant-list-card.vue?vue&type=script&lang=ts&"
import style0 from "./complex-menu-variant-list-card.vue?vue&type=style&index=0&id=31bbcac3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbcac3",
  null
  
)

export default component.exports